import { render, staticRenderFns } from "./ShortSection.vue?vue&type=template&id=2b075a12"
import script from "./ShortSection.vue?vue&type=script&lang=js"
export * from "./ShortSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports